export enum CompressFormat {
  Tar = "Tar",
  Zip = "Zip",
}
